import DefectCheckingTable from './DefectCheckingTable';

export default DefectCheckingTable;
